// extracted by mini-css-extract-plugin
export default {"onFinancePagePillButtons":"OnFinance_onFinancePagePillButtons__zmxW7"};